import jsPDF from 'jspdf';
import 'jspdf-autotable';

const formatAgeRange = (position) => {
    if (position.no_age_range === '1') {
        return 'Não se aplica';
    }
    if (position.min_age && position.max_age) {
        return `${position.min_age}-${position.max_age} anos`;
    }
    return 'Não se aplica';
};

const formatEducationLevel = (position) => {
    const detail = position.education_level_detail ? ` ${position.education_level_detail}` : '';
    return `${position.education_level_name || 'Não se aplica'}${detail}`;
};

const formatList = (items) => {
    if (!items || items.length === 0) {
        return 'Não se aplica';
    }
    return items.map(item => `• ${item}`).join('\n\n');
};

const label = (text) => ({ content: text, styles: { fontStyle: 'bold', fillColor: [255, 255, 255] } });
const sectionHeader = (text) => [{ content: text, colSpan: 4, styles: { fontStyle: 'bold', fillColor: [242, 242, 242], halign: 'left' } }];

const buildBody = (position) => [
    sectionHeader('Informações Gerais'),
    [label('CBO:'), position.cbo, label('Classe:'), position.role_class_name],
    [label('Classificação:'), position.role_classification_code, label('Setor:'), position.sector_name],
    [label('Liderança imediata:'), { content: position.leadership_position_name, colSpan: 3 }],
    [label('Faixa etária:'), { content: formatAgeRange(position), colSpan: 3 }],
    [label('Escolaridade:'), formatEducationLevel(position), label('Tempo de Experiência:'), position.experience_time || 'Não se aplica'],
    [label('Qualificação profissional:'), { content: formatList(position.professional_qualifications), colSpan: 3 }],
    [label('Competências Técnicas:'), { content: formatList(position.technical_competency_names), colSpan: 3 }],
    [label('Competências Comportamentais:'), { content: formatList(position.behavioral_competency_names), colSpan: 3 }],
    [label('Treinamentos exigidos:'), { content: formatList(position.training_names), colSpan: 3 }],
    [label('Acessos Necessários:'), { content: formatList(position.system_access_names), colSpan: 3 }],
    sectionHeader('Atribuições'),
    [{ content: formatList(position.attributions), colSpan: 4 }]
];

export const generatePositionsPdf = (positions) => {
    const doc = new jsPDF({ format: 'a4', orientation: 'portrait', unit: 'mm' });
    const marginX = 12;

    positions.forEach((position, index) => {
        if (index > 0) {
            doc.addPage();
        }

        doc.setFont(undefined, 'bold');
        doc.setFontSize(15);
        doc.text(position.role_name || '', marginX, 18);

        doc.autoTable({
            body: buildBody(position),
            startY: 22,
            margin: { left: marginX, right: marginX },
            theme: 'grid',
            styles: {
                font: 'helvetica',
                fontSize: 9,
                cellPadding: 2,
                lineColor: [50, 50, 50],
                lineWidth: 0.1,
                valign: 'top'
            },
            columnStyles: {
                0: { cellWidth: 32 },
                2: { cellWidth: 32 }
            },
            rowPageBreak: 'avoid'
        });
    });

    doc.save(`fichas-de-cargos-${new Date().toLocaleDateString('pt-BR').replace(/\//g, '-')}.pdf`);
};
